//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { axiosGet } from '../../../../axios/axios.js'
import { formatTrueFalse } from '../../../../components/helpers.js'
import TableServer from '../../../../components/Table/Table.vue'
import { checkProvidableDriverManagementAccess, createProvidableDriver } from './ProvidableDriver.js'

export default {
  components: {
    TableServer
  },
  props: {
    organizationId: {
      type: Number,
      default: null
    },
    formId: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,

      urlBase: '/service/delta/vehicleProvider/getDrivers',
      updateEvent: 'update-vehicleProviderDriver',
      filterType: 'vehicleProviderDriver',

      columns: this.prepareColumns([
        {
          name: 'name',
          label: 'ФИО',
          sortable: true
        },
        {
          name: 'phone',
          label: 'Телефон',
          sortable: true
        },
        {
          name: 'organization',
          label: 'Организация',
          sortable: true
        },
        {
          name: 'actualContractor',
          label: 'Актуальный',
          format: formatTrueFalse,
          defaultWidth: 80,
          sortable: true
        }
      ])
    }
  },
  computed: {
    providableDriverManagementAccess: function () {
      return checkProvidableDriverManagementAccess(this.$store.getters.getUser)
    },
    additionalUrlParams: function () {
      if (this.organizationId) {
        const params = {}
        params.organizationId = this.organizationId
        return params
      }
      return null
    },
    visibleColumns: function () {
      let columns = this.columns || []
      if (this.organizationId) {
        columns = columns.filter(column => column.name !== 'organization')
      }
      return columns.map(column => column.name)
    }
  },
  methods: {
    getObjectCardUrl: function (employee) {
      return this.$d_getUrlObjectCard(employee.id, 'employee', 'forkLiftDriver')
    },
    showColumnMobile: function (col) {
      const val = col.value
      const hasColumnValue = val != null && !!val && val.length > 0
      return col.showAlways || hasColumnValue
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
        if (column.sortable == null) {
          column.sortable = false
        }
      }
      return columns
    },

    onCreateProvidableDriver: function () {
      const objectParams = {}
      if (this.organizationId) {
        objectParams.contractOrganization = this.organizationId
      }

      const createConfig = { objectParams }
      createProvidableDriver(this, createConfig, objectId => {
        this.registryCmp.onObjectAdded(objectId)
      })
    }
  }
}

